module.exports = __webpack_public_path__ + "img/4.31f0c7d4.jpg";